export enum WalletTypesEnum {
  METAMASK,
  LEDGER,
  TREZOR,
  WALLET_CONNECT,
}
